/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import { useMutation } from '@apollo/client';

import { DELETE_RECON_FILE_INFO } from 'Apollo/Mutations/DataRecon';

const DeleteReconFileInfo = ({
    projectId, fileId, refetch, setToastMessage,
}) => {
    /* apollo mutation to delete file info */
    const [deleteReconFileInfo] = useMutation(DELETE_RECON_FILE_INFO, {
        variables: {
            input: {
                projectId,
                fileId,
            },
        },
    });

    /* callback function called when delete option is selected for file */
    const onDelete = async () => {
        await deleteReconFileInfo().then(() => setToastMessage('File is deleted.'));
        refetch();
    };

    return (
        <div>
            <span
                onClick={() => onDelete()}
                className="appkiticon
                        icon-delete-fill"
                style={{ marginLeft: '1rem', cursor: 'pointer' }}
                role="presentation"
            />
        </div>
    );
};

export default DeleteReconFileInfo;
